import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

import { DocumentHeaderFooterComponent } from './document-header-footer.component';
import { AddEditHeaderComponent } from './add-edit-header/add-edit-header.component';
import { AddEditFooterComponent } from './add-edit-footer/add-edit-footer.component';

@NgModule({
    declarations: [
        DocumentHeaderFooterComponent,
        AddEditHeaderComponent,
        AddEditFooterComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [
        DocumentHeaderFooterComponent
    ]
})
export class DocumentHeaderFooterModule { }
